import database from '../helpers/firebase';

export const loadChannels = () =>{
  return (dispatch, getState) => {
    database.ref('/').once('value').then((snapshot)=>{
        dispatch(channelsLoaded(snapshot.val()));
    });
  }
}

export const channelsLoaded = (channels)=>{
  return {
    type:'CHANNELS_LOADED',
    payload:channels
  }
}

export const categoryChanged = (payload) => {
  return {
    type:'CATEGORY_CHANGED',
    payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/channelList.js